<template>
    <div id='wine-club-header' class='container' :class="{'background-image' : show_background}">
        <div class='header-container' :class="{'header-padding' : add_padding}">
            <img class='logo' src="/images/wineclub/wineclublogo.png" @click='goToHome'> 
            <div  v-if='!loading' v-show='!hide_buttons' class='buttons-container'>
                <button v-show='!logged_in' @click='goToLogin' class='login-button'>Sign in</button>
                <a v-show='logged_in' class='account-link switch-text' @click='toGoLIIAccount'>Switch to Lock It In </a>
                <a v-show='logged_in && !mobile_mode' class='account-link' @click='toGoAccount'>Account </a>
                <a v-show='logged_in && mobile_mode' class='account-link' @click='toGoAccount'><i class="fa-solid fa-user"></i> </a>
                <button v-show='logged_in && !mobile_mode' @click='logout' class='login-button'>Logout</button>
                <a  class='account-link'  v-show='logged_in && mobile_mode' @click='logout'><i class="fa-solid fa-arrow-right-from-bracket"></i></a>
            </div>
            <div v-if='loading' class='loading-container'>
                <Loading/>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import {checkAuth} from "@/global/modules/functions.js";
import Loading from '@/ecom/components/loading/Loading.vue';

export default {
    components: {DynamicImageContainer, Loading},
    props:{
        'show_background': {default: true},
        'add_padding': {default: true},
        'login_changed': {}
    },
    data(){
        return{
            hide_buttons: false,
            logged_in : false,
            loading: true,
            screen_size_check_timeout: null,
            mobile_mode: false
        }
    },
    methods:{
        goToLogin(){
            this.$router.push('/wine-club/login?redirect_url=wine-club/members');
        },
        toGoAccount(){
            this.$router.push('/wine-club/members');
        },
        goToHome(){
            this.$router.push('/');
        },
        toGoLIIAccount(){
            this.$router.push('/lock-it-in/members');
        },
        async checkLoggedin(){
            this.loading = true;

            let response = await fetch(`/api/user/check-logged-in`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                if(results == true){
                    this.logged_in = true;
                }
            }

            this.loading = false;
        },
        hideShowElements(route){
            if(route == '/wine-club/login' || route == '/wine-club/login/'){
                this.hide_buttons = true;
            }

        },
        async logout(){
            let response = await fetch(`/api/user/logout`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({}),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.logged_in = false;
                this.setLogoutLocalStorage();
                window.location.href = '/';
            }
        },
        CheckMobileMode(){
            let wine_club_header = document.getElementById('wine-club-header');
            if(typeof wine_club_header !== 'undefined'){
                new ResizeObserver(()=>{
                    clearTimeout(this.screen_size_check_timeout);

                    this.screen_size_check_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error
                        if(wine_club_header.clientWidth <= 768){
                            this.mobile_mode = true;
                        }
                        else{
                            this.mobile_mode = false;
                        }
                    }, 1);
                }).observe(wine_club_header);
            }
        },
        setLogoutLocalStorage(){
            let logout_watcher = +new Date();
            localStorage.setItem('logout_watcher', logout_watcher);
        }
    },
    watch:{
      'login_changed': function(){
        this.checkLoggedin();
      }
    },
    mounted(){
        this.CheckMobileMode();
    },
    beforeMount(){
        this.checkLoggedin();
        this.hideShowElements(this.$route.path);
    }

}
</script>

<style lang="scss" scoped>
.container{
    width: 100%;
}

.background-image{
    background-color: #082917;
    background-image: url('/public/images/wineclub/wine_glass_background.jpg');
    background-size: cover;
    box-shadow: inset 0 0 0 10000px rgba(8,41,23, 0.78);
    background-repeat: no-repeat;
    background-blend-mode: screen;
}


.header-container{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
}

.header-padding{
    padding: 0px 96px;

    @media(max-width: 768px){
       padding: 0px 12px;
    }
}

.logo{
    height: 96px;
    cursor: pointer;

    @media(max-width: 768px){
        height: auto;
        width: 150px;
    }
}

.login-button{
        background: none;
        color: white;
        border-radius: 30px;
        padding: 2px 30px;
        height: 42px;
        border: 1px solid white;
        font-size: 0.9rem;
        cursor: pointer;
    }

    .buttons-container{
        display: flex;
        gap: 24px;
        align-items: center;

        @media(max-width: 768px){
            gap: 16px;
        }
    }

    .account-link{
        color: white;
        cursor: pointer;
        &:hover{
            text-decoration: underline;
        }
    }

.loading-container{
    width: 25px;
    height: 25px;
    margin-right: 40px;
}

.switch-text{
    @media(max-width: 768px){
        font-size: 0.76rem;
        font-weight: 300;
    }
}

:deep(){
   .loader {
    width: inherit;
    height: inherit;
    border: 3px solid white;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 
}
</style>